import { useEffect, useState } from 'react'
import { Text } from '@/ui'
import { TypographyStyles } from '@/styles'
// Put this in app to see crash
export const BuggyComponent = () => {
  const [isCrash, setIsCrash] = useState(false)

  useEffect(() => {
    setTimeout(() => setIsCrash(true), 3000)
  }, [])

  if (isCrash) {
    // Simulate a JS error
    throw new Error('I crashed!')
  }

  return <Text>Ok</Text>
}

const ErrorBoundaryScreen = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: window.innerHeight,
    }}
  >
    {/* // Should double check this */}
    <img
      src="https://heard-images.s3.amazonaws.com/assets/looking-at-tablet.svg"
      alt="Looking at tablet"
      className="w-[200px] h-[213px] mb-5"
    />
    <Text variant={TypographyStyles.H1} className="mb-2">
      Something went wrong on our end.
    </Text>
    <Text variant={TypographyStyles.BODY_LG}>
      Our team’s fixing it! Refresh this page in a few minutes.
    </Text>
  </div>
)

export default ErrorBoundaryScreen
